import ajax from '@/utils/ajax';
import { setDictArrToObj } from '@/utils/tools';

const header = '/web';

// 活动基本信息
export const reqInvitationInfo = async () => {
  const { data } = await ajax(`${header}/v1/dictionary/type/COMMOSSION`);
  const obj = setDictArrToObj(data);
  return obj;
};

// 获取个人账户信息
export const reqUserAccount = async () => {
  const { data } = await ajax(`${header}/v1/agent/user-account`);
  return data;
};

// 获取代理账户信息
export const reqAgentAccount = async (id) => {
  const { data } = await ajax(`${header}/v1/agent/${id}`);
  return data;
};

// 生成代理信息
export const reqAgentKey = async () => {
  const res = await ajax(`${header}/v1/agent`, {}, 'POST');
  return res;
};

// 好友明细
export const reqFriendDetail = (info) => ajax(`${header}/v1/agent/user-friend`, info);
// 好友明细列表
export const reqFriendDetailList = (info) => ajax(`${header}/v1/agent/user-friend-detail`, info);

export const reqReceive = (info) => ajax(`${header}/v1/agent/receive`, info, 'POST');

// 账户明细列表
export const reqAccountDetailList = async (info) => {
  const { data } = await ajax(`${header}/v1/agent/user-account-detail`, info);
  return data;
};

// 提现列表
export const reqAccountWithdrawList = async (info) => {
  const { data } = await ajax(`${header}/v1/agent/user-withdraw-detail`, info);
  return data;
};

// 申请提现
// eslint-disable-next-line object-curly-newline
export const reqWithdraw = async ({ alipayAccount, amount, idCardNumber, recipientName }) => {
  const res = await ajax(
    `${header}/v1/agent/withdraw`,
    {
      alipayAccount,
      amount,
      idCardNumber,
      recipientName,
    },
    'POST',
  );
  return res;
};
